<nav class="step-bar">
  <ul>
    <li>
      <div class="circle"
      [ngClass]="{ normal: configService.currentStep === 1 || configService.isCompletedWelcome }">
        
      </div>
      <!-- <svg
        version="1.1"
        id="Capa_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 512 512"
        style="enable-background: new 0 0 512 512"
        xml:space="preserve"
        width="32px"
        height="32px"
      >
        <g>
          <g>
            <path
              class="inactive"
              [ngClass]="{ normal: configService.currentStep === 1 }"
              d="M437.019,74.98C388.667,26.629,324.38,0,256,0C187.619,0,123.332,26.629,74.98,74.98C26.629,123.332,0,187.62,0,256
         s26.629,132.667,74.98,181.019C123.332,485.371,187.62,512,256,512s132.667-26.629,181.019-74.98
         C485.371,388.667,512,324.38,512,256S485.371,123.333,437.019,74.98z M378.306,195.073L235.241,338.139
         c-2.929,2.929-6.768,4.393-10.606,4.393c-3.839,0-7.678-1.464-10.607-4.393l-80.334-80.333c-5.858-5.857-5.858-15.354,0-21.213
         c5.857-5.858,15.355-5.858,21.213,0l69.728,69.727l132.458-132.46c5.857-5.858,15.355-5.858,21.213,0
         C384.164,179.718,384.164,189.215,378.306,195.073z"
            />
          </g>
        </g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g> 
        <g></g>
      </svg> -->

      <h3 [ngClass]="{ normalText: configService.currentStep === 1 || configService.isCompletedWelcome}">
        BIENVENIDO
      </h3>
    </li>
    <li>
      <div class="circle"
      [ngClass]="{ normal: configService.currentStep === 2 || configService.isCompletedStep1, inactive: configService.currentStep != 2 && !configService.isCompletedStep1 }">
        
      </div>
      <!-- <svg
        version="1.1"
        id="Capa_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 512 512"
        style="enable-background: new 0 0 512 512"
        xml:space="preserve"
        width="32px"
        height="32px"
      >
        <g>
          <g>
            <path
              class="inactive"
              [ngClass]="{ normal: configService.currentStep === 2 }"
              d="M437.019,74.98C388.667,26.629,324.38,0,256,0C187.619,0,123.332,26.629,74.98,74.98C26.629,123.332,0,187.62,0,256
         s26.629,132.667,74.98,181.019C123.332,485.371,187.62,512,256,512s132.667-26.629,181.019-74.98
         C485.371,388.667,512,324.38,512,256S485.371,123.333,437.019,74.98z M378.306,195.073L235.241,338.139
         c-2.929,2.929-6.768,4.393-10.606,4.393c-3.839,0-7.678-1.464-10.607-4.393l-80.334-80.333c-5.858-5.857-5.858-15.354,0-21.213
         c5.857-5.858,15.355-5.858,21.213,0l69.728,69.727l132.458-132.46c5.857-5.858,15.355-5.858,21.213,0
         C384.164,179.718,384.164,189.215,378.306,195.073z"
            />
          </g>
        </g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
      </svg> -->
      <h3 [ngClass]="{ normalText: configService.currentStep === 2 || configService.isCompletedStep1}">
        DATOS PERSONALES
      </h3>
    </li>
    <li>
      <div class="circle"
      [ngClass]="{ normal: configService.currentStep === 3 || configService.isCompletedStep2, inactive: configService.currentStep != 3 && !configService.isCompletedStep2}">
        
      </div>
      <!-- <svg
        version="1.1"
        id="Capa_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 512 512"
        style="enable-background: new 0 0 512 512"
        xml:space="preserve"
        width="32px"
        height="32px"
      >
        <g>
          <g>
            <path
              class="inactive"
              [ngClass]="{ normal: configService.currentStep === 3 }"
              d="M437.019,74.98C388.667,26.629,324.38,0,256,0C187.619,0,123.332,26.629,74.98,74.98C26.629,123.332,0,187.62,0,256
       s26.629,132.667,74.98,181.019C123.332,485.371,187.62,512,256,512s132.667-26.629,181.019-74.98
       C485.371,388.667,512,324.38,512,256S485.371,123.333,437.019,74.98z M378.306,195.073L235.241,338.139
       c-2.929,2.929-6.768,4.393-10.606,4.393c-3.839,0-7.678-1.464-10.607-4.393l-80.334-80.333c-5.858-5.857-5.858-15.354,0-21.213
       c5.857-5.858,15.355-5.858,21.213,0l69.728,69.727l132.458-132.46c5.857-5.858,15.355-5.858,21.213,0
       C384.164,179.718,384.164,189.215,378.306,195.073z"
            />
          </g>
        </g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
      </svg> -->
      <h3 [ngClass]="{ normalText: configService.currentStep === 3 }">
        DATOS DE CONTACTO
      </h3>
    </li>
    <li>
      <div class="circle"
      [ngClass]="{ normal: configService.currentStep === 4 || configService.isCompletedStep3, inactive: configService.currentStep != 4 && !configService.isCompletedStep3}">
        
      </div>
      <!-- <svg
        version="1.1"
        id="Capa_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 512 512"
        style="enable-background: new 0 0 512 512"
        xml:space="preserve"
        width="32px"
        height="32px"
      >
        <g>
          <g>
            <path
              class="inactive"
              [ngClass]="{ normal: configService.currentStep === 4 }"
              d="M437.019,74.98C388.667,26.629,324.38,0,256,0C187.619,0,123.332,26.629,74.98,74.98C26.629,123.332,0,187.62,0,256
         s26.629,132.667,74.98,181.019C123.332,485.371,187.62,512,256,512s132.667-26.629,181.019-74.98
         C485.371,388.667,512,324.38,512,256S485.371,123.333,437.019,74.98z M378.306,195.073L235.241,338.139
         c-2.929,2.929-6.768,4.393-10.606,4.393c-3.839,0-7.678-1.464-10.607-4.393l-80.334-80.333c-5.858-5.857-5.858-15.354,0-21.213
         c5.857-5.858,15.355-5.858,21.213,0l69.728,69.727l132.458-132.46c5.857-5.858,15.355-5.858,21.213,0
         C384.164,179.718,384.164,189.215,378.306,195.073z"
            />
          </g>
        </g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
      </svg> -->
      <h3 [ngClass]="{ normalText: configService.currentStep === 4 }">
        INFORMACIÓN ACADEMICA
      </h3>
    </li>
  </ul>
</nav>
